import styled from 'styled-components'
import { JET_IFRAME_INPUT_STYLES } from './constants'
import { colors } from 'client/styles'
import { ButtonPrimary } from 'src/comps/Button/styles'

export const JetIframeFormBase = styled.div`
  iframe {
    max-height: 48px;
  }
  #paymentErrorMsg {
    color: ${colors.red2};
    margin-block-end: 20px;
    font-weight: 700;
  }
  #old-CVC2-input,
  #old-pan-input {
    display: none;
  }
`

export const JetInputWrapper = styled.div`
  font-size: 16px;
  line-height: 1.2;
  margin-block-end: 20px;
  label {
    color: ${colors.grey2};
    margin-block-end: 5px;
    display: block;
  }
  input,
  select {
    ${JET_IFRAME_INPUT_STYLES}
  }
  #paycomet-cvc2 {
    max-width: 120px;
  }
`

export const JetInputDatesWrapper = styled.div`
  display: flex;
  max-width: 200px;
  align-items: center;
  span {
    margin-inline: 5px;
    margin-block: 0;
  }
`

export const JetButtonSubmit = styled(ButtonPrimary)`
  margin-block-end: 5px;
`
